import Exit from './Exit';

export default Exit;
